import { mapState } from 'vuex';
import ApiService from '@/services/apiService';
import MapViewMixin from '@/components/core/dtwin/map/viewMixin';
import multiSearchMixin from '@/mixins/multiSearchDigitalTwins';
import moment from 'moment';
export default {
  name: 'ViewDigitalTwinDigitalTwinMap',
  mixins: [MapViewMixin, multiSearchMixin],
  data: function () {
    return {
      active: null,
      historyFrom: null
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color']),
    setBackRouteObj() {
      return this.$route.query.edit === 'true' ? {
        path: `/digitaltwin-mgmt/${this.active}`
      } : {
        path: '/digitaltwin-mgmt/',
        query: {
          active: this.active
        }
      };
    }
  },
  watch: {
    historyFrom() {
      this.$refs.mapInstance.debouncedRequestClusterRequest();
    }
  },
  created() {
    this.active = this.$route.params.twinId;
  },
  mounted() {
    this.loadInitialData();
    this.historyFrom = moment(new Date()).subtract(2, 'months').unix();
  },
  methods: {
    handleHistoryFromPicked(dateObject) {
      this.historyFrom = dateObject.from;
    },
    breadCrumbsPath() {
      return [{
        to: '/digitaltwin-mgmt',
        text: this.$i18n_t('Common.drawer.dTwins')
      }, this.$i18n_t('DigitalTwin.VirtualDevice.map.title')];
    },
    // from multi-search-mixin, forward to cluster-request
    fetchList() {
      if (this.$refs && this.$refs.mapInstance) {
        this.$refs.mapInstance.debouncedRequestClusterRequest();
      }
      this.fetchGeoMetaInfos();
    },
    fetchGeoMetaInfos() {
      const selectedRootTwinId = this.$route.params.twinId ? parseInt(this.$route.params.twinId) : null;
      const searchItems = this.searchItems.map(item => ({
        variable: item.param,
        // support item.search.value === null, so do not simply have a >search.value || search< expression
        search: (item.search || {}).value === undefined ? item.search : item.search.value,
        key: item.key
      }));
      return ApiService.digitalTwinFetchGeoMetaInfos(this, selectedRootTwinId, searchItems).then(data => {
        this.stateKeys = data.keyList;
        this.twinTags = data.tagList;
        this.floorList = data.floorList;
      }).catch(error => {
        console.error('Error loading map-twin-state-keys', error);
      });
    },
    async fetchTwinData() {
      this.hasLoadedInitially = false;
      if (this.$refs.mapInstance) {
        this.$refs.mapInstance.hasLoadedMarkers = false;
      }
      const data = await this.loadTree();
      if (data && (data.clusters && data.clusters.length === 1 || data.dtwins && data.dtwins.length === 1)) {
        this.$refs.mapInstance.flyToCamera();
      }
      return this.fetchGeoMetaInfos();
    },
    getClusterContent(cluster, bounds) {
      if (!cluster) {
        this.selectedCluster = {};
        return;
      }
      const selectedRootTwinId = this.$route.params.twinId ? parseInt(this.$route.params.twinId) : null;
      const searchItems = this.searchItems.map(item => ({
        variable: item.param,
        // support item.search.value === null, so do not simply have a >search.value || search< expression
        search: (item.search || {}).value === undefined ? item.search : item.search.value,
        key: item.key
      }));
      ApiService.digitalTwinGetGeoClusterContent(this, cluster.id, selectedRootTwinId, this.indoorFloorDtwinId, [[bounds['_ne'].lng, bounds['_ne'].lat], [bounds['_sw'].lng, bounds['_sw'].lat]], searchItems, this.excludeZones).then(data => {
        this.selectedCluster = {
          ...cluster,
          items: data.dtwins
        };
      }).catch(error => {
        console.error('Error loading map-twin-clusters', error);
      });
    },
    loadTree(bounds = undefined) {
      this.$store.state.app.load = 10;
      this.$store.state.app.loading = true;
      const selectedRootTwinId = this.$route.params.twinId ? parseInt(this.$route.params.twinId) : null;
      const searchItems = this.searchItems.map(item => ({
        variable: item.param,
        // support item.search.value === null, so do not simply have a >search.value || search< expression
        search: (item.search || {}).value === undefined ? item.search : item.search.value,
        key: item.key
      }));
      return ApiService.digitalTwinFetchGeoClusters(this, selectedRootTwinId, this.indoorFloorDtwinId, bounds, this.selectedStateKey, searchItems, {
        excludeZones: this.excludeZones,
        hideStatelessPolygons: this.hideStatelessPolygons
      }).then(data => {
        this.calculateBoundingBox(data);
        this.markerItems = data.dtwins;
        return data;
      }).catch(error => {
        console.error('Error loading map-twin-clusters', error);
      }).finally(() => {
        this.$store.state.app.loading = false;
      });
    }
  }
};